import { inject, InjectionToken, Provider } from "@angular/core";
import { SubmissionDocumentTypesListSignalState } from "../../types";
import { SUBMISSION_DOCUMENT_TYPES_SIGNAL_STORE } from "../signal-store";

export const SUBMISSION_DOCUMENT_TYPES_TOKEN = new InjectionToken<SubmissionDocumentTypesListSignalState>(
  'Submission Document Types Signal Store',
);

export const SUBMISSION_DOCUMENT_TYPES_PROVIDER: Provider = {
  provide: SUBMISSION_DOCUMENT_TYPES_TOKEN,
  useClass: SUBMISSION_DOCUMENT_TYPES_SIGNAL_STORE
};

export function submissionDocumentTypesTokenizer() {
  return inject(SUBMISSION_DOCUMENT_TYPES_TOKEN);
}
